import { render } from "./NavCatHeader.vue?vue&type=template&id=0545c9b8&scoped=true"
import script from "./NavCatHeader.vue?vue&type=script&lang=js"
export * from "./NavCatHeader.vue?vue&type=script&lang=js"

import "./NavCatHeader.vue?vue&type=style&index=0&id=0545c9b8&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0545c9b8"]])

export default __exports__